import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Requirement.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatTime,
} from "../../utils/const";
import { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { HiOutlineMailOpen } from "react-icons/hi";
import JobPost from "../../components/common/JobPost";
//   import SideIcon from "./SideIcon";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
import { GoDuplicate } from "react-icons/go";
import { HiOutlineCalendar } from "react-icons/hi2";
import { IoTimeOutline } from "react-icons/io5";
import { PiChair } from "react-icons/pi";
import { BsBarChartLine } from "react-icons/bs";
import { BsPinMap } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import {
  getPostRequirement,
  getRequirementCandidates,
  UpdateAction,
} from "../../redux/post-requirement/postRequirementSlice";
import { allSkill } from "../../redux/common/skillSlice";
import { allLocation } from "../../redux/common/locationSlice";

const whichStatus = (value) => {
  let status;
  if (value === "Active") {
    status = "Open";
  } else if (value === "On Hold") {
    status = "Hold";
  } else if (value === "Closed") {
    status = "Close";
  }
  return status;
};

const MoreViewDetails = () => {
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [actionName, setActionName] = useState("");
  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const profile = useSelector((state) => state.profile.data);
  const postCandidateData = useSelector(
    (state) => state.postrequirement.candidateData
  );
  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );
  const { row } = location?.state || {};
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const skillData = useSelector((state) => state.skill.data);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const postRequirementStatus = useSelector(
    (state) => state.postrequirement.status
  );

  const [data, setData] = useState(
    location.state || JSON.parse(localStorage.getItem("postJobDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem("postJobDetails", JSON.stringify(location.state));
      setData(location.state);
    }
  }, [location.state]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
  };

  useEffect(() => {
    if (data) {
      let userID = data?.row?.job_id;
      dispatch(getRequirementCandidates(userID));
    }
  }, [data]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  const getPostingName = (name) => {
    let subname;
    if (name === "high") {
      subname = "High Priority";
    } else if (name === "low") {
      subname = "Low Priority";
    }
    return subname;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const handleOnClickChangeAction = () => {
    let updatedValues = {
      job_status: actionName,
    };
    let jobId = data?.row?.job_id;
    dispatch(UpdateAction({ updatedValues, jobId }));
  };

  useEffect(() => {
    if (postRequirementStatus === "update_action") {
      let userID = data?.row?.job_id;
      dispatch(getRequirementCandidates(userID));
      dispatch(getPostRequirement());
      handleClose();
      handleCloseAction();
    }
  }, [postRequirementStatus, row]);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
  }, []);

  useEffect(() => {
    if (row) {
      setActionName(data?.row?.job_status);
    }
  }, [row]);

  const handleSelect = (text) => {
    setActionName(text);
    handleOpen();
  };

  return (
    // <RootComponents>
    <>
      <Box className={styles.search_candidate_stucture}>
        <Box className={styles.track_submissions_heading}>
          <Box>
            <Typography>
              Job ID: <b>{data?.row?.job_id}</b>
            </Typography>
            <Typography>
              Post Categories: <b>{getPostingName(data?.row?.posting_type)}</b>
            </Typography>
            <Typography>
              Date:{" "}
              <b>
                {data?.row?.created_at !== undefined &&
                  formatDate(data?.row?.created_at)}
                ,{" "}
                {data?.row?.created_at !== undefined &&
                  formatTime(data?.row?.created_at)}
              </b>
            </Typography>
            {/* <Typography>
              Job Avalable to Respond In:{" "}
              <b>
                {data?.row?.job_available_to_respond !== undefined &&
                  formatDate(data?.row?.job_available_to_respond)}{" "}
                {data?.row?.job_available_to_respond !== undefined &&
                  formatTime(data?.row?.job_available_to_respond)}{" "}
              </b>
            </Typography> */}
          </Box>
          <span>
            <Typography
              sx={{ fontSize: "25px !important", textAlign: "center" }}
            >
              <b>{data?.row?.total_apply_candidate_count}</b>
            </Typography>
            <Typography>Portal Response </Typography>
          </span>
        </Box>

        <Box
          className={styles.profile_and_submit}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                <Typography sx={{ marginTop: "10px !important" }}>
                  {data?.row?.client_name !== "" &&
                    data?.row?.client_name !== null && (
                      <b>Client : {data?.row?.client_name}</b>
                    )}
                </Typography>
                <Typography>
                  <b>
                    {" "}
                    Job Post: Looking for {data?.row?.no_of_opening}{" "}
                    {data?.row?.job_title} at{" "}
                    {data?.row?.location?.length > 0 &&
                      getPreferLocationNames(data?.row?.location)}
                  </b>
                </Typography>
                <Typography>
                  <b>
                    {data?.row?.job_title}, Exp {data?.row?.experience} Years{" "}
                    {/* {getLocationById(data?.row?.location)} */}
                  </b>
                </Typography>
                <Typography>
                  <b>{convertArrayToString(data?.row?.requirement_type)} </b>
                </Typography>
                <Typography>
                  <b> {data?.row?.mode_of_interview} </b>
                </Typography>
                <Typography>
                  <b>
                    {data?.row?.rate !== "" || data?.row?.rate !== null
                      ? `$${data?.row?.rate}`
                      : "Not disclosed"}{" "}
                  </b>
                </Typography>
              </span>
            </span>
          </Box>
          <span>
            <Typography
              sx={{ fontSize: "25px !important", textAlign: "center" }}
            >
              <b>{data?.row?.no_of_opening}</b>
            </Typography>
            <Typography>
              <b>No. Of Opening</b>{" "}
            </Typography>
          </span>
        </Box>

        <Box className={styles.candidate_text} sx={{ marginBottom: "14px" }}>
          <span>
            <Typography>
              <b>{data?.row?.job_description}</b>
            </Typography>
            <Typography>
              <b>{data?.row?.skills}</b>
            </Typography>
          </span>
        </Box>

        <div style={{ backgroundColor: "#fff", padding: "5px 10px 5px 10px" }}>
          <Box className={styles.recruiter_profile}>
            <div>
              <img src={profile?.profile?.profile_picture} alt="" />
              <span style={{ color: customTextColor }}>
                <Typography>
                  <b>{profile?.profile?.full_name}</b>
                </Typography>
                <Typography sx={{ marginTop: "10px !important" }}>
                  {profile?.profile?.designation} –{" "}
                  {profile?.profile?.company_name}
                </Typography>
                <Typography>
                  Ph: {profile?.profile?.mobile_no} | E-Mail:{" "}
                  {profile?.profile?.email}
                </Typography>
              </span>
            </div>
          </Box>
        </div>
      </Box>

      <Box sx={{ backgroundColor: "#dfebf7" }}>
        <Typography
          sx={{ marginLeft: "20px", position: "relative", top: "10px" }}
        >
          <b>Portal Response</b>
        </Typography>

        {requirementLoading === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : (
          <Box className={styles.requiter_profile_section}>
            {postCandidateData?.candidates?.length > 0 ? (
              postCandidateData?.candidates?.map((candidate) => {
                return (
                  <JobPost
                    name={candidate?.candidate_resume_profile?.fullName}
                    skill={candidate?.candidate_resume_profile?.currentJobTitle}
                    date={candidate?.candidate_resume_profile?.createdAt}
                    location={getPreferLocationNames(
                      candidate?.candidate_resume_profile?.preferLocation
                    )}
                    btn1={
                      candidate?.progress?.length === 0
                        ? "View & Accept"
                        : "Accepted"
                    }
                    btn2="Update Status"
                    candidate={candidate}
                    row={row}
                    requirementLoading={requirementLoading}
                  />
                );
              })
            ) : (
              <h5 style={{ textAlign: "center", marginTop: "15px" }}>
                No Response Found
              </h5>
            )}

            <Box className={styles.send_update_btns}>
              <button
                onClick={() =>
                  navigate("/jobpost/add", {
                    state: { row: row, type: "republis" },
                  })
                }
                style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}
              >
                Republish
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{
                    color: "#fff",
                    width: "7rem",
                    border: "1.5px solid #4287f5",
                    padding: "6px 10px",
                  }}
                >
                  {whichStatus(actionName)}
                </button>
                <div className="dropdown-menu">
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("Active")}
                  >
                    Open
                  </a>
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("On Hold")}
                  >
                    Hold
                  </a>
                  <a
                    className="dropdown-item"
                    style={{ backgroundColor: "#fff" }}
                    onClick={() => handleSelect("Closed")}
                  >
                    Close
                  </a>
                </div>
              </div>
            </Box>
          </Box>
        )}
      </Box>

      <Dialog
        fullScreen={fullScreen}
        open={openAction}
        // onClose={handleCloseAction}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
            <Box>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="Active"
                  checked={actionName === "Active"}
                  onChange={() => handleOnChangeAction("Active")}
                />
                <label class="form-check-label" htmlFor="exampleRadios1">
                  Open
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="On Hold"
                  checked={actionName === "On Hold"}
                  onChange={() => handleOnChangeAction("On Hold")}
                />
                <label class="form-check-label" htmlFor="exampleRadios2">
                  Hold
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios3"
                  value="Closed"
                  checked={actionName === "Closed"}
                  onChange={() => handleOnChangeAction("Closed")}
                />
                <label class="form-check-label" htmlFor="exampleRadios3">
                  Close
                </label>
              </div>
            </Box>
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOpen}
              >
                Change
              </button>
              <button
                sx={{ backgroundColor: "#97B6F1" }}
                onClick={handleCloseAction}
              >
                Cancel
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        maxWidth="sm"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Job Action Change</b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change action to {actionName}
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                // onClick={handleOnClickStatusChange}
                onClick={handleOnClickChangeAction}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }} onClick={handleClose}>
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default MoreViewDetails;
